import { useContext, useState } from "react";
import { CounterCtx } from "../../context/context";
import { RESET_STATE_KUNJUNGAN, getKunjungan } from "../helpers";
import { useDatatablesServerSide } from "App/hooks";
import { changeKunjungan, changeLoading } from "../../context/actions";
import { defaultToastError } from "App/utils/helpers";

function useReloadTableKunjungan() {
	const { state, dispatch } = useContext(CounterCtx);

	const [formFilter, setFormFilter] = useState(RESET_STATE_KUNJUNGAN);

	const handleChange = (text) => (e) => {
		setFormFilter({
			...formFilter,
			[text]: e.target.value,
		});
	};

	const setNewData = async (
		pages = formFilter.pages,
		limit = formFilter.limit,
		formSearch = formFilter
	) => {
		dispatch(changeLoading(true));
		const response = await getKunjungan(formSearch, pages, limit);
		if (response.state) {
			dispatch(
				changeKunjungan({
					state: response.status,
					message: response.message,
					data: response.data,
					count: response.count,
					sisa: response.sisa,
					limit: response.limit,
					pages: response.pages,
				})
			);
			dispatch(changeLoading(false));
		} else {
			dispatch(
				changeKunjungan({
					state: "",
					message: "",
					data: [],
					count: 1,
					sisa: true,
					limit: 10,
					pages: 1,
				})
			);
			dispatch(changeLoading(false));
			defaultToastError(response.message);
		}
	};

	const {
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	} = useDatatablesServerSide({
		setNewData: setNewData,
		additionalProps: formFilter,
	});

	return {
		setNewData,
		loading: state.loading,
		handleChange,
		formFilter,
		setFormFilter,
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	};
}

export default useReloadTableKunjungan;
